import { Button } from '@ff-it/ui';
import { forwardRef, ReactNode } from 'react';
export const InputButton = forwardRef(({ children, onClick }: { children: ReactNode; onClick?: any }, ref) => (
  <Button type="button" size="sm" variant="secondary" onClick={onClick} ref={ref as any}>
    {children}
  </Button>
));
